module.exports = "<div class=\"grid-two-col mt-base-double\">\n  <relationship></relationship>\n  <reverse-relationship [entityIdDetails]=\"entityIdDetails\"></reverse-relationship>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/relations/entity-relations.component.html
// module id = 2259
// module chunks = 0